import React from "react";
import BasicModal from "./BasicModal";
import {
	Box,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import { sizes } from "../scenarioSetupNewUtils";
import MultipleSelectChip from "./MultipleSelectChip";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./editScenarioNewSlice";
import { useEffect } from "react";
import { auto } from "@popperjs/core";

const commonHeight = sizes.h35;
const SW = sizes.w300;

export default function DefineLinkDataSources() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const { selectedDSs, selectedPDS, dataSources, editScDetails } = setupState;

	useEffect(() => {
		if (editScDetails !== null) {
			// let list = [];
			// editScDetails.scenarioDatasource.forEach((item) => {
			// 	list.push(item.dataSourceName);
			// });
			// dispatch(setState("selectedDSs", list));
		}
	}, [editScDetails]);

	const handlePrimaryDataSource = (event) => {
		
		const dataSource = event.target.value;
		const id = dataSources.find(
			(source) => source.dataSourceName === dataSource
		).dataSourceID;
		dispatch(setState("selectedPDS", dataSource));
		dispatch(setState("primaryDataSourceID", id));
	};

	return (
		<grid container columns={12} justifyContent="space-between" rowSpacing={0} >
			{/* <Box sx={{ mt: 5, marginLeft:auto, }}>
				<Typography sx={{ color: "lightBlue.main", fontWeight: "bold" }} className="compHeading">
					Define and Link Data Sources
				</Typography>
			</Box> */}
			<Grid container sx={{mb: 4, mt: -.5,}}>
				<Grid item sm={8}>
					<Box>
						<MultipleSelectChip />
					</Box>
				</Grid>

				<Grid item sx={12} sm={6} md={4} lg={4}>
				<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
					<Box sx={{mt: 2, mr:2, width: "50%"}} md={2} lg={2}>
						<FormControl sx={{ width: "100%" }}>
							<InputLabel id="demo-simple-select-label">
								Primary Data Source
							</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={selectedPDS}
								label="primary data sources"
								sx={{
									height: commonHeight,
									width: SW,
									color: "black.main",
									mt: 1,
								}}
								onChange={handlePrimaryDataSource}
							>
								{selectedDSs.map((source, index) => {
									if (source != 'SIT') {
									return (
										<MenuItem key={index} value={source}>
											{source}
										</MenuItem>
									);
								}
								})}
							</Select>
						</FormControl>
					</Box>
					<Box sx={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "flex-end",
						mr:2
                  	}}>
						<BasicModal />
					</Box>
					</Box>
				</Grid>
			</Grid>
		</grid>
	);
}
